import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'src/shared/components/form/checkbox';
import { List } from 'src/shared/components/list';
import { Tag } from 'src/shared/components/tag';
export function ClassItem({ classItem }) {
    const { t } = useTranslation();
    const { setValue, watch } = useFormContext();
    const currentClasses = watch('classes');
    function select(classId) {
        if (currentClasses.includes(classId)) {
            // remove
            setValue('classes', currentClasses.filter((id) => id !== classId), { shouldValidate: true });
            return;
        }
        // add
        setValue('classes', [...currentClasses, classId], {
            shouldValidate: true,
            shouldDirty: true
        });
    }
    return (_jsx(List.Item, { children: _jsxs("div", { className: "flex w-full items-center gap-2", children: [_jsx(Checkbox, { "data-testid": "select-class", id: `selection-class-${classItem.hashId}`, onChange: () => select(classItem.hashId), labelClassName: "text-small text-neutral-900 pt-[0.125rem]", checked: currentClasses.includes(classItem.hashId), label: classItem.name || t('modules.form.classes.class_a') }), _jsx("span", { className: "h-6 flex-shrink-0", children: classItem.defaultClass && (_jsx(Tag, { context: "brand", children: t('modules.form.classes.default_class') })) })] }) }));
}
